<template>
  <section class="calculator section">
    <span id="calculator" class="anchor"></span>
    <div class="calculator__container section__container container">
      <h2 class="calculator__heading heading-reset section__heading">
        <span>калькулятор</span> вознаграждения
      </h2>
      <CalculatorApp />
    </div>
  </section>
</template>

<script>
import CalculatorApp from '@/components/MainPage/CalculatorApp.vue'
export default {
  components: { CalculatorApp }
}
</script>
